import { Button, DatePicker, message, Modal, Select } from "antd";
import React, { useEffect, useRef, useState } from "react";

import { actionTypeOptions, eventOptions, numberOfRetriesOptions, recurringOptions, scheduleTypeOptions, } from "./testData";
import AddActionTriggerByActionCompletion from "./AddActionTriggerByActionCompletion";

import calendar from "../../assets/icons/calendar.png";
import { controller } from "./controller";
import { generateSimpleId } from "./utils";
import EmailSmsTemplates from "./EmailTemplates";

export default function CreateActoinModal({ showAddActionModal, setShowAddActionModal, boardId, campaignId, actions }) {
  const [formData, setFormData] = useState({ action_type: "", template_data: {}, retry_number: 1, action_trigger: {trigger_type: "", } });
  const [loading, setLoading] = useState(false)
  const [selectedTemplate, setSelectedTemplate] = useState(undefined);
  const [selectedSmsTemplate, setSelectedSmsTemplate] = useState(undefined);

  useEffect(() => {
    if (selectedTemplate && formData.action_type === "email") {
      setFormData(prevData => ({
        ...prevData,
        multinotify: { 
          ...prevData.multinotify, 
          notify_name: prevData.multinotify && prevData.multinotify.notify_name ||     generateSimpleId(),
          triggertype: "event_type", 
          email_template: selectedTemplate 
        }
      }));
    } else if (selectedSmsTemplate && formData.action_type === "sms") {
      setFormData(prevData => ({
        ...prevData,
        multinotify: { 
          ...prevData.multinotify, 
          notify_name: prevData.multinotify && prevData.multinotify.notify_name ||       generateSimpleId(),
          triggertype: "event_type", 
          sms_template: selectedSmsTemplate 
        }
      }));
    }
  }, [selectedTemplate, selectedSmsTemplate, formData.action_type]);  

  // {"campaign": {"id": , "actions": [
  //   {
  //     "action_type": "email", "template_data": {}, "retry_number": 2,
  //     "action_trigger": {"trigger_type": "recurring","recurring_period":"annual"}
  //   }
  // ]}}
  const handleAddAction = async () => {
    const actionToSend = {
      campaign: {
        id: campaignId,
        actions: [ formData ]
      }
    }
    try {
      setLoading(true)
      const response = await controller.addAudiencSelectorsToBoard(boardId, actionToSend)
      if (response.status == 204) {
        message.success(response.message)
        setShowAddActionModal(false)
      }
    } catch (err) {
      message.error("Error occurred while sending the actions to the board")
      console.error("Send actions to baord", err)
    } finally {
      setLoading(false)
    }
  }

  const handleDatePick = (date, dateString) => {
    if (date) {
      // Create a new Date object from the selected date
      const selectedDate = new Date(date);
      // Set time to 00:00:00.000Z (midnight UTC)
      selectedDate.setUTCHours(0, 0, 0, 0);
      // Format to ISO string "2025-11-02T00:00:00.000Z"
      const formattedDate = selectedDate.toISOString();      
      // Update the formData with trigger_time
      setFormData(prevData => ({ ...prevData, action_trigger: { ...prevData.action_trigger, trigger_time: formattedDate } }));
    } else {
      // If date is cleared, remove the trigger_time
      setFormData(prevData => ({ ...prevData, action_trigger: { ...prevData.action_trigger, trigger_time: "" } }));
    }
  }

  console.log('selectedTemplate', selectedTemplate)

  return (
    <>
      <Modal
        title={<span style={{ fontSize: 16, fontWeight: 500 }}>Add Action</span>}
        onCancel={() => setShowAddActionModal(false)}
        open={showAddActionModal}
        width={700}
        footer={
          <Button type="primary" style={{ width: "100%", padding: "20px 0" }} onClick={handleAddAction} loading={loading}>
            Add
          </Button>
        }
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 20, marginTop: 20 }}>
          <div>
            <p style={{ fontSize: 16 }}>Schedule</p>

            <SelectWithTitle
              options={scheduleTypeOptions}
              placeholder="Selecte Schedule Type"
              title="Schedule Type"
              field="action_trigger"
              fieldInner="trigger_type"
              formData={formData}
              setFormData={setFormData}
            />

            {formData.action_trigger.trigger_type === "event" ? (
              <SelectWithTitle
                options={eventOptions}
                placeholder="Selecte Event"
                title="Event"
                field="action_trigger"
                fieldInner="trigger_event"
                formData={formData}
                setFormData={setFormData}
              />
            ) : formData.action_trigger.trigger_type === "recurring" ? (
              <SelectWithTitle
                options={recurringOptions}
                placeholder="Selecte Recurring Option"
                title="Recurring Option"
                field="action_trigger"
                fieldInner="recurring_period"
                formData={formData}
                setFormData={setFormData}
              />
            ) : formData.action_trigger.trigger_type === "manual trigger" ? (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "start", gap: 10, marginBottom: 25 }}>
                <span style={{ fontSize: 16 }}>Specific Date</span>

                <DatePicker
                  suffixIcon={<img src={calendar} alt="calendar" />}
                  name="trigger_time"
                  placeholder="Select End Date"
                  style={{ width: "100%", borderRadius: 10, border: "1px solid #6B43B5", padding: "10px 20px" }}
                  onChange={handleDatePick}
                />
              </div>
            ) : formData.action_trigger.trigger_type === "action completion" ? (
              <AddActionTriggerByActionCompletion actions={actions} setFormData={setFormData}/>
            ) : null}
          </div>

          <div>
            <p style={{ fontSize: 16 }}>Action</p>

            {/* Action Type */}
            <SelectWithTitle
              options={actionTypeOptions}
              placeholder="Selecte Action Type"
              title="Action Type"
              field="action_type"
              formData={formData}
              setFormData={setFormData}
            />

            {// Email Templates
              formData.action_type === "email" && 
              <EmailSmsTemplates selectedTemplate={selectedTemplate} setSelectedTemplate={setSelectedTemplate}/> 
            }
            {// SMS Templates
              formData.action_type === "sms" && 
              <EmailSmsTemplates selectedTemplate={selectedSmsTemplate} setSelectedTemplate={setSelectedSmsTemplate} isSms/> 
            }

            <SelectWithTitle
              options={numberOfRetriesOptions}
              placeholder="Selecte Retry Numbers"
              title="Number of Retries"
              field="retry_number"
              formData={formData}
              setFormData={setFormData}
            />
          </div>
        </div>
      </Modal>

    </>
  );
}

function SelectWithTitle({ options, setFormData, formData, placeholder, title, field, fieldInner, }) {

  // const uniqueName = useRef(generateSimpleId());

  const handleChange = (value) => {
    setFormData((prevData) => {
      if (field === "action_type" && value !== "email" && value !== "sms"){
        const {multinotify, ...rest} = prevData
        return { ...rest, [field]: 'custom action', ['custom_action_method']: value }
      }
      if (field === "action_type" && (value === "email" || value === "sms") ) // email_template will be updated by useEffect when template is selected
        return { ...prevData, 
          [field]: value, 
          multinotify: { notify_name: generateSimpleId(), triggertype: "event_type", email_template: "", sms_template: ""},
        }
      if (!fieldInner) return { ...prevData, [field]: value };
      return { ...prevData, [field]: { ...prevData[field], [fieldInner]: value } };
    });
  };
  // Fixed value access logic
  let value;
  if (field === "action_type" && formData[field] !== "email" && formData[field] !== "sms") 
    value = formData['custom_action_method'];
  else if (!fieldInner) value = formData[field];
  else if (fieldInner && formData[field]) value = formData[field][fieldInner];
  
  
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "start", gap: "10px", marginBottom: 25 }}>
      <label style={{ fontSize: 14 }}>{title}</label>
      <Select
        options={options}
        placeholder={placeholder}
        value={value || undefined}
        onChange={handleChange}
        className="custom-style-selection"
        style={{ width: "100%", display: "flex", alignItems: "center" }}
      />
    </div>
  );
}
